import React, {Component} from 'react';
import { AuthenticatedUser, stopTimer, hasPerm, adminloadTP } from "../../api";
import { List, HelpCircle, BarChart2 } from 'react-feather';
import BDBQueryCube from '../../pages/pageParts/bdbQueryCube';
import TournamentPageTemplate from './tournamentPageTemplate'

class TournamentConfig extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            buildBallotStatusColor: 'danger'
        }

    }
    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ pid: pid, tData: d2.tournamentPage, tUsers: d2.tUsers, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user } = this.state;

            var showAdmin = hasPerm(user, tData.permTags[0]);

            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Configuration - ${user.displayname}`} title3=""
                bcTitle="Configuration Dashboard" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]} 
            >                
                {showAdmin &&
               
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Instructions" subtitle="Start here for information" qType="none" link={`/pages/lp/${tData.adminHelpPageId}`} icon={<HelpCircle className="font-success" />} bg="bg-success"/>
                            </div>
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Tournament Templates" subtitle="Use existing tournament templates" qType="none" link={`/tournament/config/events/${tData._id}`} icon={<BarChart2 className="font-info" />} bg="bg-info"/>
                            </div>  
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Events" subtitle="Define Events" qType="none" link={`/tournament/config/events/${tData._id}`} icon={<BarChart2 className="font-info" />} bg="bg-info"/>
                            </div>     
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Rounds" subtitle="Define Rounds" qType="none"  link={`/tournament/config/rounds/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Ballots" subtitle="Define Ballots" qType="none"  link={`/tournament/config/ballots/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>  
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Prompts" subtitle="Define prompts for Limited Prep events" qType="none"  link={`/tournament/config/prompts/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Paneling" subtitle="Define Paneling options" qType="none"  link={`/tournament/config/ballots/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Statistics and Qualification" subtitle="Configure Career and Seasonal Rankings" qType="none" link={`/tournament/config/documents/${tData._id}`} icon={<List className="font-info"  />} bg="bg-info" />
                            </div>                                                                                                                                                          
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Documents and Links" subtitle="Configure Documents and Links" qType="none" link={`/tournament/config/documents/${tData._id}`} icon={<List className="font-info"  />} bg="bg-info" />
                            </div>                              
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Branding" subtitle="Give it your look" qType="none" link={`/tournament/config/branding/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>  
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Dates & Options" subtitle="Configure dates and options" qType="none" link={`/tournament/config/options/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Rooms" subtitle="Configure Rooms" qType="none" link={`/tournament/config/rooms/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>  
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Shop" subtitle="Setup your mechandise for the shop" qType="none" link={`/tournament/config/rooms/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>                                                                                       
                        </div>                      
                    </div>
                }
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentConfig;